import { ProfileHttpGateway } from 'src/adapters/http/ProfileHttpGateway'
import { GetCityInfo } from './GetCityInfo'
import { GetProfile } from './GetProfile'
import { GetSubdivisions } from './GetSubdivisions'

// Сборка зависимостей вручную: гейтвей (вилка) вставляется в сценарии.
const profileGateway = new ProfileHttpGateway()

export const getProfile = new GetProfile(profileGateway)
export const getCityInfo = new GetCityInfo(profileGateway)
export const getSubdivisions = new GetSubdivisions(profileGateway)
